import { render, staticRenderFns } from "./DetailIncomingInfo.vue?vue&type=template&id=b2ef84c8&"
import script from "./DetailIncomingInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailIncomingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports